import { render, staticRenderFns } from "./BoWineries.vue?vue&type=template&id=bc4cbf06&"
import script from "./BoWineries.vue?vue&type=script&lang=js&"
export * from "./BoWineries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports